"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageUI = exports.getPageParams = void 0;
var _reactRouter = require("react-router");
var _ramda = require("ramda");
var _selectors = require("../../../../bus/ui/selectors");
var _book = require("../../../routes/book");
var _constants = require("./constants");
var getPageParams = exports.getPageParams = (0, _ramda.pipe)(function (_ref) {
  var router = _ref.router;
  return router.location.pathname;
}, function (pathname) {
  var pathes = [(0, _reactRouter.matchPath)(pathname, {
    path: _book.book.offer
  }), (0, _reactRouter.matchPath)(pathname, {
    path: _book.book.offerV2
  }), (0, _reactRouter.matchPath)(pathname, {
    path: _book.book.hotel
  })];
  var targetPath = (0, _ramda.find)(Boolean, pathes);
  return targetPath.params;
});
var getPageUI = exports.getPageUI = (0, _ramda.partialRight)(_selectors.getUI, [{
  key: _constants.UI_KEY
}]);